export const getMapLink = (myLocation: any, point: any) =>
  `https://www.google.com/maps/dir/?api=1&origin=${
    myLocation ? `${myLocation.latitude},${myLocation.longitude}` : ''
  }&destination=${point.latitude},${point.longitude}`;
